import { render } from "./SpheresSection.vue?vue&type=template&id=f33ea4ba&scoped=true"
const script = {}

import "./SpheresSection.vue?vue&type=style&index=0&id=f33ea4ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f33ea4ba"]])

export default __exports__